export const SERVERS_HOST_LIST = ['https://lfs.rest/api/','https://eu.lfs.rest/api/']
export const COUNTRIES_SNG = ["AB","KG","TM","AM","MD","UZ","BY","RU","UA","KZ","TJ" ]
export const LANG_DEFAULT = 'ru'
